
  import { defineComponent } from 'vue';

  export default defineComponent({
    name: 'StatisticsPdfTitle',
    props: {
      title: {
        type: String,
        required: true,
      },
    },
  });
